import { Skeleton, Typography, useMediaQuery } from "@mui/material"
import theme from "@skistarab/mui-theme"

const TITLE_SKELETON = {
  width: 120,
  mobileHeight: 24,
  tabletHeight: 30,
} as const

type TitleSectionProps = {
  title?: string
  titleLoading: boolean
  contentId: string
}

const TitleSection = ({
  title,
  titleLoading,
  contentId,
}: TitleSectionProps) => {
  const isTablet = useMediaQuery(theme.breakpoints.up("md"))

  if (titleLoading) {
    return (
      <Skeleton
        variant="text"
        width={TITLE_SKELETON.width}
        height={
          isTablet ? TITLE_SKELETON.tabletHeight : TITLE_SKELETON.mobileHeight
        }
      />
    )
  }

  return (
    <Typography
      component="div"
      fontSize={isTablet ? "20px" : "16px"}
      fontWeight={600}
      id={`${contentId}-label`}
    >
      {title}
    </Typography>
  )
}

export default TitleSection
